import { Modifier } from "@dnd-kit/core";

export const restrictToParentVerticalBounds: Modifier = ({
  transform,
  draggingNodeRect,
  active
}) => {
  if (!draggingNodeRect) return transform;
  const node = document.getElementById(active.id.toString()); // you should wrap your draggable component in another element and give it an id
  if (!node || !node.parentElement) return transform;

  const parent = node.parentElement;
  const parentRect = parent.getBoundingClientRect();

  const draggedTop = draggingNodeRect.top + transform.y;
  const draggedBottom = draggedTop + draggingNodeRect.height;

  if (draggedTop < parentRect.top) {
    const delta = parentRect.top - draggingNodeRect.top;
    return { ...transform, y: delta };
  }

  if (draggedBottom > parentRect.bottom) {
    const delta =
      parentRect.bottom - draggingNodeRect.top - draggingNodeRect.height;
    return { ...transform, y: delta };
  }

  return transform;
};
